export const DEFAULT_LANGUAGE_NAME = "EN";
export const SUPPORTED_LANGUAGES = [
  { id: 1, name: "English", locale: "EN" },
  { id: 2, name: "Slovenština", locale: "SK" },
  { id: 3, name: "German", locale: "DE" },
  { id: 4, name: "Українська", locale: "UK" },
  { id: 5, name: "Русский", locale: "RU" },
];
